import { TableRowCell } from './styled';
import { Grid, Text } from '@simplywallst/ui-core';
import { RouterLink } from '@redux-first-router-link';
import { useTracking } from 'react-tracking';

type CompanyCell = {
  tickerSymbol: string | null;
  name: string | null;
  canonicalURL: string | null;
};

interface Props {
  company: CompanyCell;
}

export const SymbolCell = ({ company }: Props) => {
  const { trackEvent } = useTracking({
    type: 'track',
  });

  return (
    <TableRowCell>
      <RouterLink
        noUnderline
        to={company.canonicalURL + '/dividend' || ''}
        onClick={() => {
          trackEvent({
            modifier: 'EstimatedFuturePaymentTableCompany',
            action: 'click',
          });
        }}
      >
        <Grid
          templateColumns="1fr"
          templateColumnsSm="80px 1fr"
          alignItems="center"
        >
          <Text typography="xSmallStrong" color="chart01" lineClamp={1}>
            {company.tickerSymbol ?? ''}
          </Text>

          <Text typography="tiny" color="textSofter" isTruncated>
            {company.name ?? ''}
          </Text>
        </Grid>
      </RouterLink>
    </TableRowCell>
  );
};
